module.exports = __webpack_public_path__ + "static/media/cranio-home-blured.1921a5a8.png";